// extracted by css-extract-rspack-plugin
export default {"Pearl":"Pearl-module__Pearl__WIsQ_"};